import React from 'react';
import { motion } from 'framer-motion';

const Orders = () => {
  // 模拟订单数据
  const orders = [
    {
      id: 'ORD-001',
      date: '2024-01-15',
      status: 'Delivered',
      total: 'S$89.90',
      items: [
        { name: 'Nintendo Joycon Pikachu', quantity: 1, price: 'S$45.90' },
        { name: 'Wireless Keyboard', quantity: 1, price: 'S$44.00' }
      ]
    },
    {
      id: 'ORD-002',
      date: '2024-01-10',
      status: 'Processing',
      total: 'S$67.50',
      items: [
        { name: 'Karaoke Speaker', quantity: 1, price: 'S$67.50' }
      ]
    },
    {
      id: 'ORD-003',
      date: '2024-01-05',
      status: 'Shipped',
      total: 'S$123.40',
      items: [
        { name: 'Gaming Chair', quantity: 1, price: 'S$123.40' }
      ]
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'Delivered':
        return 'bg-green-100 text-green-800';
      case 'Processing':
        return 'bg-yellow-100 text-yellow-800';
      case 'Shipped':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 pb-20">
      <div className="container mx-auto px-4 py-8">
        <motion.h1 
          className="text-3xl font-bold text-white mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          My Orders
        </motion.h1>

        {orders.length === 0 ? (
          <motion.div 
            className="text-center py-12"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <div className="text-gray-400 text-6xl mb-4">📦</div>
            <h3 className="text-xl text-white mb-2">No orders yet</h3>
            <p className="text-gray-400">Start shopping to see your orders here</p>
          </motion.div>
        ) : (
          <div className="space-y-6">
            {orders.map((order, index) => (
              <motion.div
                key={order.id}
                className="bg-gray-800 rounded-lg p-6 shadow-lg"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-lg font-semibold text-white">Order #{order.id}</h3>
                    <p className="text-gray-400 text-sm">{order.date}</p>
                  </div>
                  <div className="text-right">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(order.status)}`}>
                      {order.status}
                    </span>
                    <p className="text-white font-bold text-lg mt-2">{order.total}</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <h4 className="text-white font-medium">Items:</h4>
                  {order.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex justify-between items-center bg-gray-700 rounded p-3">
                      <div>
                        <p className="text-white font-medium">{item.name}</p>
                        <p className="text-gray-400 text-sm">Qty: {item.quantity}</p>
                      </div>
                      <p className="text-white font-semibold">{item.price}</p>
                    </div>
                  ))}
                </div>

                <div className="flex justify-end mt-4 space-x-3">
                  <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors">
                    View Details
                  </button>
                  {order.status === 'Delivered' && (
                    <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors">
                      Reorder
                    </button>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Orders;
